import React, { Component } from 'react';
import LoadingDots from '../Loadingdot/Loadingdots';
import './style.css';

class AssignGiftcouponView extends Component {
  constructor(props){
    super(props)

    this.state={
      totalCount500:'',
      totalCount100:'',
      totalCount50:'',
      totalCount20:'',
      totalCount10:'',
      inputCouponNo500:'',
      inputCouponNo100:'',
      inputCouponNo50:'',
      inputCouponNo20:'',
      inputCouponNo10:'',
      showInputCouponNo500: true,
      showInputCouponNo100: true,
      showInputCouponNo50: true,
      showInputCouponNo20: true,
      showInputCouponNo10: true,
      totalAmount500: 0,
      totalAmount100: 0,
      totalAmount50: 0,
      totalAmount20: 0,
      totalAmount10: 0,
      totalAmountPayable:0,
      showViewSuccess: false,
      showViewSuccessMessage:'',
    };
    this.showPaymentRequest = this.showPaymentRequest.bind(this);
    this.onChange = this.onChange.bind(this);
    this.makeGiftCouponsAmount = this.makeGiftCouponsAmount.bind(this);
}


componentDidMount(){
  if(this.props.giftcouponCountData.countData){
    this.setState({
        totalCount500 : this.props.giftcouponCountData.countData.C500,
        totalCount100 : this.props.giftcouponCountData.countData.C100,
        totalCount50  : this.props.giftcouponCountData.countData.C50,
        totalCount20  : this.props.giftcouponCountData.countData.C20,
        totalCount10  : this.props.giftcouponCountData.countData.C10,
    });
    if((500 <= parseInt(this.props.userGiftcouponOnlineTransactionData.currentPay.totalAmount) && (this.props.giftcouponCountData.countData.C500>0))){
      this.setState({ showInputCouponNo500 : false});
    }
    if((100 <= parseInt(this.props.userGiftcouponOnlineTransactionData.currentPay.totalAmount) && (this.props.giftcouponCountData.countData.C100>0))){
      this.setState({ showInputCouponNo100 : false});
    }
    if((50 <= parseInt(this.props.userGiftcouponOnlineTransactionData.currentPay.totalAmount) && (this.props.giftcouponCountData.countData.C50>0))){
      this.setState({ showInputCouponNo50 : false});
    }
    if((20 <= parseInt(this.props.userGiftcouponOnlineTransactionData.currentPay.totalAmount )&& (this.props.giftcouponCountData.countData.C20>0))){
      this.setState({ showInputCouponNo20 : false});
    }
    if((10 <= parseInt(this.props.userGiftcouponOnlineTransactionData.currentPay.totalAmount) && (this.props.giftcouponCountData.countData.C10>0))){
      this.setState({ showInputCouponNo10 : false});
    }
  }
}

componentWillReceiveProps(nextprops){
  if(nextprops.giftcouponPaymentSuccess === true){
    this.setState({showViewSuccess: true, showViewSuccessMessage: nextprops.giftcouponPaymentData.message });
  }
}

showPaymentRequest(){
  this.props.showPaymentRequest();
}

onChange(e){

  const re = /^[0-9\b]+$/;
  if (e.target.value === '' || re.test(e.target.value)) {
    this.setState({[e.target.name]: e.target.value});

    let inputNo=0;
    if(e.target.value !== ""){
      inputNo = parseInt(e.target.value)
    }

    if( e.target.name === "inputCouponNo500"){

      if(inputNo<= parseInt(this.state.totalCount500)){
        let value =  inputNo* 500;
        let total = value + this.state.totalAmount100 + this.state.totalAmount50 + this.state.totalAmount20 + this.state.totalAmount10;
        this.setState({totalAmount500 : value, totalAmountPayable: total});
      }else{
        alert("You didn't have enough coupon");
        let total = this.state.totalAmount100 + this.state.totalAmount50 + this.state.totalAmount20 + this.state.totalAmount10;
        this.setState({inputCouponNo500 : '',totalAmount500:0, totalAmountPayable: total});
      }      
    }else if(e.target.name === "inputCouponNo100"){
      if(inputNo<= parseInt(this.state.totalCount100)){
        let value = inputNo * 100;
        let total = this.state.totalAmount500 + value + this.state.totalAmount50 + this.state.totalAmount20 + this.state.totalAmount10;
        this.setState({totalAmount100 : value, totalAmountPayable: total});
      }else{
        alert("You didn't have enough coupon");
        let total = this.state.totalAmount500 + this.state.totalAmount50 + this.state.totalAmount20 + this.state.totalAmount10;
        this.setState({inputCouponNo100 : '',totalAmount100:0, totalAmountPayable: total});
      }
    }else if(e.target.name === "inputCouponNo50"){
      if(inputNo<= parseInt(this.state.totalCount50)){
        let value = inputNo * 50;
        let total = this.state.totalAmount500 + this.state.totalAmount100 + value + this.state.totalAmount20 + this.state.totalAmount10;
        this.setState({totalAmount50 : value, totalAmountPayable: total});
      }else{
        alert("You didn't have enough coupon");
        let total = this.state.totalAmount500 + this.state.totalAmount100 + this.state.totalAmount20 + this.state.totalAmount10;
        this.setState({inputCouponNo50 : '',totalAmount50:0, totalAmountPayable: total});
      }
    }else if(e.target.name === "inputCouponNo20"){
      if(inputNo<= parseInt(this.state.totalCount20)){
        let value = inputNo * 20;
        let total = this.state.totalAmount500 + this.state.totalAmount100 + this.state.totalAmount50 + value + this.state.totalAmount10;
        this.setState({totalAmount20 : value, totalAmountPayable: total});
      }else{
        alert("You didn't have enough coupon");
        let total = this.state.totalAmount500 + this.state.totalAmount100 + this.state.totalAmount50 + this.state.totalAmount10;
        this.setState({inputCouponNo20 : '',totalAmount20:0, totalAmountPayable: total});
      } 
    }else if(e.target.name === "inputCouponNo10"){
      if(inputNo<= parseInt(this.state.totalCount10)){
        let value = inputNo * 10;
        let total = this.state.totalAmount500 + this.state.totalAmount100 + this.state.totalAmount50 + this.state.totalAmount20 + value;
        this.setState({totalAmount10 : value, totalAmountPayable: total});
      }else{
        alert("You didn't have enough coupon");
        let total = this.state.totalAmount500 + this.state.totalAmount100 + this.state.totalAmount50 + this.state.totalAmount20;
        this.setState({inputCouponNo10 : '',totalAmount10:0, totalAmountPayable: total});
      }
    }

  }else{
    this.setState({[e.target.name]: ''});
    alert("Please enter only numeric value 1 to 9");
  }
}

makeGiftCouponsAmount(){
  if( parseInt(this.state.totalAmountPayable) === parseInt(this.props.userGiftcouponOnlineTransactionData.currentPay.totalAmount) ){
    let data ={};
    let arrayCoupon = [];
    if(this.state.inputCouponNo500 !== ''){
      //data.coupon500Total = this.state.inputCouponNo500;
      arrayCoupon.push( "500:"+this.state.inputCouponNo500);
    }

    if(this.state.inputCouponNo100 !== ''){
      //data.coupon100Total = this.state.inputCouponNo100;
      arrayCoupon.push( "100:"+this.state.inputCouponNo100);
    }

    if(this.state.inputCouponNo50 !== ''){
      //data.coupon50Total = this.state.inputCouponNo50;
      arrayCoupon.push( "50:"+this.state.inputCouponNo50);
    }

    if(this.state.inputCouponNo20 !== ''){
      //data.coupon20Total = this.state.inputCouponNo20;
      arrayCoupon.push( "20:"+this.state.inputCouponNo20);
    }

    if(this.state.inputCouponNo10 !== ''){
     // data.coupon10Total = this.state.inputCouponNo10;
     arrayCoupon.push( "10:"+this.state.inputCouponNo10);
    }
    data.arrayCoupon = arrayCoupon;
    data.transactionID = this.props.userGiftcouponOnlineTransactionData.currentPay._id;    
    data.userID = this.props.userGiftcouponOnlineTransactionData.currentPay.user_id;
    data.totalAmount = this.props.userGiftcouponOnlineTransactionData.currentPay.totalAmount;
    data.totalPoints = this.props.userGiftcouponOnlineTransactionData.currentPay.totalPoints;
    //console.log(data);
    this.props.giftCouponOnlinePaymentPayUser(data)
    
  }else{
    alert("Please check yours total amount and payable amount or coupons.");
  }
}
  
  render(){
    
    let showtranactionView ="";
    if(this.state.showViewSuccess){
      showtranactionView = <div>
        <tr>{this.state.showViewSuccessMessage}</tr>
        <button onClick= {this.showPaymentRequest} className="goPaymentBtn"> Go to payments </button>
      </div>
    }else{
      showtranactionView = <div> <div><h4>Please assign coupons:</h4></div>
              <table className = "couponAssignTable" >
              <thead >
                <th >Total coupon</th>
                <th >CouponAmont</th>
                <th>No.</th>
                <th>Amount</th>
              </thead>
                <tbody>
                  <tr>
                    <td>{this.state.totalCount500}</td>
                    <td>500</td>
                    <td><input name="inputCouponNo500" value={this.state.inputCouponNo500} onChange={this.onChange}  disabled={this.state.showInputCouponNo500}></input></td>
                    <td>{this.state.totalAmount500}</td>
                  </tr>

                  <tr>
                    <td>{this.state.totalCount100}</td>
                    <td>100</td>
                    <td><input name="inputCouponNo100" value={this.state.inputCouponNo100} onChange={this.onChange} disabled={this.state.showInputCouponNo100}></input></td>
                    <td>{this.state.totalAmount100}</td>
                  </tr>

                  <tr>
                    <td>{this.state.totalCount50}</td>
                    <td>50</td>
                    <td><input name="inputCouponNo50" value={this.state.inputCouponNo50} onChange={this.onChange} disabled={this.state.showInputCouponNo50}></input></td>
                    <td>{this.state.totalAmount50}</td>
                  </tr>

                  <tr>
                    <td>{this.state.totalCount20}</td>
                    <td>20</td>
                    <td><input name="inputCouponNo20" value={this.state.inputCouponNo20} onChange={this.onChange} disabled={this.state.showInputCouponNo20}></input></td>
                    <td>{this.state.totalAmount20}</td>
                  </tr>

                  <tr>
                    <td>{this.state.totalCount10}</td>
                    <td>10</td>
                    <td><input name="inputCouponNo10" value={this.state.inputCouponNo10} onChange={this.onChange} disabled={this.state.showInputCouponNo10}></input></td>
                    <td>{this.state.totalAmount10}</td>
                  </tr>
                  <tr><td></td><td></td><td>Total amount  </td><td>{this.state.totalAmountPayable + " USD"}</td></tr>
                </tbody>
              </table>
              <button className="submitGiftCouponsAmount" onClick = {this.makeGiftCouponsAmount}>Submit</button>
              </div>
    }
    
    return (
      <div className = "regPage">
       <div className = "form">
        <div className = "GNNheading"><h1>Coupon Distribution</h1></div> 
          <br/><button  className = "backbutton" onClick = {this.showPaymentRequest} >Back</button><br/>  
          <div className = "registerform">       
            <div><h4>Current Transaction:</h4>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Requested Amount :  {this.props.userGiftcouponOnlineTransactionData.currentPay.totalAmount} &nbsp; USD,&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Total points : {this.props.userGiftcouponOnlineTransactionData.currentPay.totalPoints}<br/>
            </div><br/>
            {showtranactionView}
          </div>
        </div>
      </div>
    );
  }
}
export default AssignGiftcouponView;



// WEBPACK FOOTER //
// ./src/components/PaymentRequest/assignGiftcouponView.js